import L0 from '@src/assets/level/l-0.svg';
import L1 from '@src/assets/level/l-1.svg';
import L2 from '@src/assets/level/l-2.svg';
import L3 from '@src/assets/level/l-3.svg';
import L4 from '@src/assets/level/l-4.svg';
import M1 from '@src/assets/medal/m-1.svg';
import M2 from '@src/assets/medal/m-2.svg';
import M3 from '@src/assets/medal/m-3.svg';
import M4 from '@src/assets/medal/m-4.svg';
import D1 from '@src/assets/medal/d-1.svg';
import D2 from '@src/assets/medal/d-2.svg';
import D3 from '@src/assets/medal/d-3.svg';
import D4 from '@src/assets/medal/d-4.svg';

export const PER_LEVEL_SCORE = 100;

// 根据分数计算等级
export const analysisScore = (score: number) => {
  const overflowScore = score % PER_LEVEL_SCORE;
  const level = (score - overflowScore) / PER_LEVEL_SCORE + 1;

  return {
    overflowScore,
    level
  };
};

// 根据等级返回勋章列表
export const analysisImg = (level: number) => {
  const haveList = [];
  const AllMedal = [
    { img: M1, title: '到达2级即可获得此勋章', disableImg: D1 },
    { img: M2, title: '到达5级即可获得此勋章', disableImg: D2 },
    { img: M3, title: '到达10级即可获得此勋章', disableImg: D3 },
    { img: M4, title: '到达20级即可获得此勋章', disableImg: D4 }
  ];

  if (level >= 2) {
    haveList.push(AllMedal.shift());
  }
  if (level >= 5) {
    haveList.push(AllMedal.shift());
  }
  if (level >= 10) {
    haveList.push(AllMedal.shift());
  }
  if (level >= 20) {
    haveList.push(AllMedal.shift());
  }

  return {
    haveList,
    notHaveList: AllMedal
  };
};

// 根据等级返等级icon
export const analysisLevelImg = (level: number) => {
  if (level < 2) {
    return {
      img: L0,
      color: '#B2B2B2'
    };
  } else if (level >= 2 && level < 5) {
    return {
      img: L1,
      color: '#B3DF37'
    };
  } else if (level >= 5 && level < 10) {
    return {
      img: L2,
      color: '#37EAED'
    };
  } else if (level >= 10 && level < 20) {
    return {
      img: L3,
      color: '#9B9BEF'
    };
  } else {
    return {
      img: L4,
      color: '#EFCB4A'
    };
  }
};
